import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
  ListGroup,
  ListGroupItem,
  CardFooter,
  CardHeader,
} from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { Triangle } from "react-loader-spinner";
import ServiceModule from "../../../services/KangarooServices/ServiceModule";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import toast from "react-hot-toast";

const Service = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await ServiceModule.getList();
      setData(result);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const toggleDelete = () => setIsOpenDelete(!isOpenDelete);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDelete();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await ServiceModule.delete(selectedDeleteItem.id);
        fetchData();
        toast.success("Selected Item deleted successfully");
      } catch (error) {
        toast.error(error?.response?.data?.message || "Failed to delete page");
      } finally {
        toggleDelete();
        setSelectedDeleteItem(null);
      }
    }
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Service" pageTitle="Content Management" />

        <Row className="mb-4">
          <Col className="col-auto">
            <Button color="success" onClick={() => navigate("/service/create")}>
              <i className="ri-add-line align-bottom me-1"></i> Add Service
            </Button>
          </Col>
        </Row>

        {loading ? (
          <div className="my-3 d-flex justify-content-center align-items-center">
            <Triangle height="100" width="100" color="#556ee6" />
          </div>
        ) : data?.length === 0 ? (
          <Row>
            <Col>
              <p>No partners available. Please add a partner.</p>
            </Col>
          </Row>
        ) : (
          <Row className="g-4">
            {data?.map((partner) => {
              const isWhite =
                partner?.bannerTextColorCode?.toLowerCase() === "#fff" ||
                partner?.bannerTextColorCode?.toLowerCase() === "#ffffff";
              return (
                <Col md={4} key={partner.id} className="mb-4">
                  <Card
                    className="shadow-sm border-0 h-100 position-relative hover-shadow cursor-pointer"
                    style={{ transition: "all 0.3s", overflow: "hidden" }}
                  >
                    <CardHeader>
                      <small className="text-muted">{partner?.slug}</small>
                    </CardHeader>
                    <CardBody className="">
                      {/* Partner Name */}
                      <CardTitle
                        tag="h5"
                        className="mb-3 fw-bold"
                        style={{ color: `${partner?.bannerTextColorCode}` }}
                      >
                        {partner.name}
                      </CardTitle>
                      <div
                        className="content-preview small "
                        style={{ overflow: "hidden", lineHeight: "1.4" }}
                        dangerouslySetInnerHTML={{
                          __html:
                            partner.mainDescription?.length > 400
                              ? partner.mainDescription.slice(0, 400) + "..."
                              : partner.mainDescription,
                        }}
                      />
                    </CardBody>

                    {/* Edit/Delete Buttons */}
                    <CardFooter className="bg-light">
                      <div className="d-flex justify-content-between">
                        {partner?.bannerButtonText && (
                          <div className="">
                            <Button
                              className="btn btn-sm"
                              style={{
                                backgroundColor: partner?.bannerButtonColorCode,
                                borderColor: partner?.bannerButtonColorCode,
                                color: isWhite ? "#000" : "#fff",
                              }}
                            >
                              {partner?.bannerButtonText}
                            </Button>
                          </div>
                        )}
                        <div className="d-flex gap-2">
                          <Button
                            color="warning"
                            size="sm"
                            onClick={(e) => {
                              e.stopPropagation(); // Prevent card click
                              navigate(`/service/update/${partner.slug}`);
                            }}
                            title="Edit Service"
                          >
                            <i className="ri-edit-line"></i>{" "}
                          </Button>

                          <Button
                            color="danger"
                            size="sm"
                            onClick={() => handleDeleteClick(partner)}
                            title="Delete Service"
                          >
                            <i className="ri-delete-bin-line"></i>{" "}
                          </Button>
                        </div>
                      </div>
                    </CardFooter>
                  </Card>
                </Col>
              );
            })}
          </Row>
        )}
      </Container>
      <DeleteModal
        show={isOpenDelete}
        onCloseClick={toggleDelete}
        onDeleteClick={handleDelete}
      />
    </div>
  );
};

export default Service;
